module.exports = __webpack_public_path__ + "static/woodlandgown-10565881cebf28963562c2bab876cb4a.jpeg";